<template>
  <div :class="$style.functions">
    <div class="container section">
      <p class="dingbeauty-sub-title fancy-title">Functions</p>
      <h2 class="dingbeauty-title is-dotted">整合您所需要的一切功能</h2>
      <div class="function-container">
        <div class="function-item" v-for="(item, index) in functionList" :key="index">
          <img :src="item.img" alt="" />
          <h3 class="title" v-html="item.title"></h3>
          <p class="sub-title" v-html="item.subTitle"></p>
        </div>
      </div>
    </div>
    <img class="img-left" src="@assets/dingbeauty-images/home/background01@1.png" alt="" />
    <img class="img-right" src="@assets/dingbeauty-images/home/background01@1.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'DingBeautyFunctions',
  props: {
    functionList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" module>
.functions {
  $color-primary: #e3c192;
  background: rgb(227, 193, 146, 0.04) 0% 0% no-repeat padding-box;
  position: relative;

  :global {
    .img-left,
    .img-right {
      display: none;
    }

    .dingbeauty-title {
      margin-bottom: 3rem;
    }

    .function-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px 18px;
    }

    .function-item {
      position: relative;
      padding: 24px 10px;
      border: 1px solid $color-primary;
      text-align: center;

      img {
        position: absolute;
        top: 0;
        left: 50%;
        background: #fff;
        transform: translate(-50%, -60%);
        padding: 4px;
      }

      .title {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 1rem;
        color: $color-primary;
      }

      .sub-title {
        font-size: 12px;
        margin-bottom: 0;
        line-height: 1.7;
        color: #545662;
      }
    }
  }
}

@media (min-width: 576px) {
  .functions {
    :global {
      .only-mobile {
        display: none;
      }
    }
  }
}

@media (min-width: 768px) {
  .functions {
    :global {
      .dingbeauty-title {
        margin-bottom: 5rem;
      }

      .function-container {
        grid-template-columns: repeat(2, 1fr);
      }
      .function-item {
        padding: 32px 24px;
        text-align: left;

        img {
          left: 1rem;
          transform: translate(0, -60%);
        }

        .title {
          font-size: 20px;
        }

        .sub-title {
          font-size: 14px;
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .functions {
    :global {
      .function-container {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}

@media (min-width: 1400px) {
  .functions {
    :global {
      .function-container {
        grid-template-columns: repeat(4, 1fr);
      }

      .function-item {
      }

      .img-left,
      .img-right {
        position: absolute;
        display: block;
      }

      .img-left {
        bottom: 10%;
        left: 0;
        transform: rotate(180deg);
        width: 200px;
      }

      .img-right {
        top: 20%;
        right: 0;
        width: 240px;
      }
    }
  }
}
</style>
